import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, useMediaQuery,
} from '@mui/material';
import * as actions from "../../../../store/actions";
import Spinner from '../../../../components/Spinner/index';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import Timeline from '../../../../components/ActionLogsTimeline/index';
import { i18n } from '../../../../translate/i18n';


const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-around',
    minHeight: '10rem',
  },
  servicesContainer: {
    marginTop: '0.5rem',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0.5rem'
  },
  title: {
    fontSize: '0.9rem',
  },
  subtitle: {
    fontSize: '0.7rem',
  },
  chipContainer: {
    padding: '0.5rem 0 0 0',
  },
  chip: {
    cursor: 'pointer',
    margin: '0.1rem',
  },
  actionsNotFound: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
};

const FormEquipmentsLogs = (props) => {
  const dispatch = useDispatch();
  const equipId = props.match.params.id;

  const fetchEquipmentTimeline = useCallback(
    () => dispatch(actions.fetchEquipmentsTimelineById(equipId)),
    [equipId]
  );

  const timeline = useSelector(state => state.equipments.timeline);
  const loadingTimeline = useSelector(state => state.equipments.loadingTimeline);

  useEffect(() => {
    fetchEquipmentTimeline();
  }, [equipId]);

  return (
    <>
      <Tabs {...props} selected={'timelineTab'} />
        <Container maxWidth='md' style={styles.container}>
        {loadingTimeline && <Spinner style={{ paddingTop: 30 }} />}
        {!loadingTimeline && timeline.length === 0 &&
          <div style={styles.actionsNotFound}>{i18n.t('formEquipmentsLogs.actionsNotFound')}</div>}
        {!loadingTimeline && timeline.length > 0 &&
        <Timeline data={timeline} spinner={loadingTimeline} />}
        </Container>
    </>
  )
}

export default FormEquipmentsLogs;
